module.exports = __webpack_public_path__ + "img/客户登记.8628fb68.png";